import { FC } from "react"
import ReactQuill from "react-quill"

import { PromotionBlock, TermsBlock } from "../types/types"

import "react-quill/dist/quill.snow.css"

type Props = {
  block: TermsBlock
  onChange: (patch: Partial<PromotionBlock>) => void
}

const quillModules = {
  toolbar: [[{ header: [2, 3, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["link"], ["clean"]]
}

const quillFormats = ["header", "bold", "italic", "underline", "list", "bullet", "link"]

export const TermsBlockEditor: FC<Props> = ({ block, onChange }) => {
  const props = block.props ?? {}

  return (
    <div className="space-y-2 border border-[rgba(255,255,255,0.12)] rounded-lg p-4 bg-[#050816]">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-sm">Terms & Conditions</h3>
      </div>

      <div>
        <label className="label block mb-1 text-xs uppercase opacity-70">Title</label>
        <input
          className="input input-bordered w-full input-sm"
          value={props.title ?? ""}
          onChange={(e) =>
            onChange({
              props: {
                ...props,
                title: e.target.value
              }
            })
          }
          placeholder="Terms & Conditions"
        />
      </div>

      <div>
        <label className="label block mb-1 text-xs uppercase opacity-70">Content</label>
        <div className="bg-white text-black rounded-md overflow-hidden">
          <ReactQuill
            value={props.html ?? ""}
            onChange={(value) =>
              onChange({
                props: {
                  ...props,
                  html: value
                }
              })
            }
            modules={quillModules}
            formats={quillFormats}
          />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 text-xs">
          <input
            type="checkbox"
            className="checkbox checkbox-xs"
            checked={!!props.collapsible}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  collapsible: e.target.checked
                }
              })
            }
          />
          <span>Collapsible</span>
        </label>

        {props.collapsible && (
          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              className="checkbox checkbox-xs"
              checked={!!props.initiallyOpen}
              onChange={(e) =>
                onChange({
                  props: {
                    ...props,
                    initiallyOpen: e.target.checked
                  }
                })
              }
            />
            <span>Open by default</span>
          </label>
        )}
      </div>
    </div>
  )
}
